import { motion } from 'framer-motion';
import Dropdown from './dropdown.js';
import { useWorkbooks } from '../contexts/WorkbookContext';
import '../styles/taskbar.css';

const Taskbar = () => {
    const workbooks = useWorkbooks() || [];

    const sortedWorkbooks = [
        ...workbooks.filter(wb => wb.name.includes("Kinder")),
        ...workbooks.filter(wb => !wb.name.includes("Kinder")),
    ];

    const resourceItems = [
        { label: 'Overview Video', action: () => window.open('https://youtu.be/bkaYkrJ2Dag', '_blank') },
        { label: 'Slides', action: () => window.location.href = 'https://www.txel.org/media/egfi5nwq/dual-language-immersion.pptx' },
        { label: 'HQIM Implementation Resources (PDF)', action: () => window.open('https://www.txel.org/media/srmbecdq/hqim-dl-mapping.pdf', '_blank') },
        { label: 'English Implementation Guide (PDF)', action: () => window.open('https://drive.google.com/file/d/18QjPu6asFpTHGY6WB_1Q8tAokmgcsisr/view?usp=sharing', '_blank') },
        { label: 'Spanish Implementation Guide (PDF)', action: () => window.open('https://drive.google.com/file/d/1gzpuhiHIKADDVdsO8sX9KE6Fevo1zE-l/view?usp=sharing', '_blank') }
    ];

    return (
        <div className="taskbar">

            <div className="taskbar__buttons">
                {workbooks.length > 0 && (
                    <>
                        <motion.div
                            className="taskbar__button"
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1, duration: 0.3 }}
                        >
                            <Dropdown
                                title="Home"
                                items={[]}
                                workbookName=""
                            />
                        </motion.div>

                        <motion.div
                            className="taskbar__button"
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1, duration: 0.3 }}
                        >
                            <Dropdown
                                title="Resources"
                                items={resourceItems}
                                workbookName=""
                            />
                        </motion.div>

                        {sortedWorkbooks.map((wb, index) => (
                            <motion.div
                                className="taskbar__button"
                                key={index}
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: (index + 1) * 0.1, duration: 0.3 }}
                            >
                                <Dropdown title={wb.name} items={wb.sheets} workbookName={wb.name} />
                            </motion.div>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
};

export default Taskbar;